<script>
  import {onMount } from "svelte";
	import { fade } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'

  export let info
  let selected = Object.keys(info)[0]
  function showInfo(evt, name) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(name).style.display = "flex";
        }
    onMount(() => {
      showInfo(null, 'construction_awards')
    })

</script>

<!-- <svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="gradient" gradientTransform="rotate(90)">
    <stop stop-color="#fff" offset="0"/>
    <stop stop-color="#c05f2c" stop-opacity="0" offset="1"/>
    </linearGradient>
  </defs>
  <text id="ah-text" font-family="proxima-nova" stroke-width="2" stroke="url(#gradient)" fill="#fffffff" fill-opacity="0" style="text-transform: uppercase;">Awards & Honors</text>
</svg>
<h2>Awards and Honors</h2> -->

<!-- Tab links -->
<div class="tab">
  {#each Object.keys(info) as label}
    <button class={selected.includes(label) ? 'active tablink':' tablink'} on:click={(e) => {showInfo(e, `${label.replace(" ", "_")}`); selected=label;}}>{label.toUpperCase()}</button>
  {/each}
</div>

<!-- Tab content -->
{#each Object.keys(info) as label}
  <div id={label.replace(" ", "_")} class="tabcontent" in:fade={{ duration: 700, easing: sineInOut }} out:fade={{ duration: 650, easing: sineInOut, delay: 200 }} >
    {#if info[label].content}
      <div class="content">
        {#each info[label]['content'] as i}
        <div class="row">
          <div class="year">{i.year}</div>
          <div class="items">{@html i.items}</div>
        </div>
        {/each}
      </div>
    {/if}
    <div transition:fade class="lightbox" style="background-image:url('{info[label].img}');"></div>
  </div>
{/each}
  